import { render } from "./AppVariablesModal.vue?vue&type=template&id=4a9dd008&scoped=true"
import script from "./AppVariablesModal.vue?vue&type=script&lang=js"
export * from "./AppVariablesModal.vue?vue&type=script&lang=js"

import "./AppVariablesModal.vue?vue&type=style&index=0&id=4a9dd008&scoped=true&lang=css"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9dd008"]])

export default __exports__